export const  Environment = Object.freeze({
    DEVELOP: Symbol("DEVELOP"),
    PRODUCTION: Symbol("PRODUCTION")
});